import angular from 'angular';
import { LoginService } from './login.service.js';
import { LoginInAlcmeonController } from './login-in-alcmeon.controller.js';
import { CompanySelectionController } from './company-selection.controller';
import { PreLoginController } from './pre-login.controller';
import { LoginOptionSelectionController } from './login-option-selection.controller';

angular
  .module('login.controller', [])
  .factory('LoginFactory', LoginService.LoginFactory)
  .controller('CompanySelectionController', CompanySelectionController)
  .controller('LoginInAlcmeonController', LoginInAlcmeonController)
  .controller('PreLoginController', PreLoginController)
  .controller('LoginOptionSelectionController', LoginOptionSelectionController)
  ;
